declare global {
  interface Window {
    __jsLoadFallbackTimer?: number
  }
}

function hideJsLoadFallback() {
  if (typeof window !== 'undefined' && window.__jsLoadFallbackTimer) {
    clearTimeout(window.__jsLoadFallbackTimer)
    window.__jsLoadFallbackTimer = undefined
  }
  const fallback = document.getElementById('js-load-fallback')
  if (fallback) fallback.style.display = 'none'
}

export { hideJsLoadFallback }
